import { useContext, useEffect, useState } from "react";
import { MaintenanceServices } from
    "lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation";
import { ToastMessageContext } from "lib/contexts/message_context";
import { getOrganisationId } from "lib/utils/common_utils";


const useGetBaseDetails = () => {
    const message = useContext(ToastMessageContext);

    const [baseStation, setBaseStation] = useState([]);

    const getBaseDetails = async () => {
        try {
            const params = {
                organisation_id: getOrganisationId(),
            };

            const res = await MaintenanceServices.getBaseStation(params);

            if (res) {
                setBaseStation(res.data);
            }
        } catch (error) {
            message.showToastMessage({
                message: "Something went wrong. Try again!",
                variant: "error",
            });
        }
    };

    useEffect(() => {

        getBaseDetails();

    }, []); // ✅ SAME AS YOUR PROJECT PARTS HOOK

    return baseStation;
};

export default useGetBaseDetails;
